import React from "react";
import { useDispatch, useSelector } from "react-redux";
import FormRadioGroupInput from "./form/formRadioGroupInput.component";
import FormText from "./form/formText.component";
import ContainerBox from "./common/containerBox.component";
import { stateProps } from "../types";
import { changeTermsAndConditions } from "../actions/index";

const TermsAndCondition: React.FC = () => {
  const dispatch = useDispatch();

  const items = ["I accept", "I don’t accept"];

  const termsAndConditions = useSelector(
    (state: { router: History; doctorInfo: stateProps }) => state.doctorInfo.termsAndConditions
  );

  const onInputChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const { value } = event.target;
    dispatch(changeTermsAndConditions(value));
  };

  return (
    <React.Fragment>
      <ContainerBox>
        <FormText
          number={"26"}
          title={
            "Do you agree to the Terms & Conditions as stated in the oDoc Service Retention Agreement given below"
          }
        />
        <FormRadioGroupInput
          onInputChange={onInputChange}
          value={termsAndConditions}
          items={items}
          termsAndConditions={true}
        />
      </ContainerBox>
    </React.Fragment>
  );
};

export default TermsAndCondition;
